import { useLayoutEffect, useMemo, useRef } from 'react';
import { debounce } from 'lodash';

/**
 * Returns a stable debounced function that always calls the latest `callback`
 * without resetting the debounce timer across component re-renders, and
 * automatically cancels any pending invocation on unmount.
 */
export default function useDebouncedCallback(callback, delay = 350) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const debounced = useMemo(
    () =>
      debounce((...args) => {
        if (callbackRef.current) {
          return callbackRef.current(...args);
        }
        return undefined;
      }, delay),
    [delay]
  );

  useLayoutEffect(() => {
    return () => {
      debounced.cancel();
    };
  }, [debounced]);

  return debounced;
}
